import { Injectable, inject } from '@angular/core';
import { STORAGE_TOKEN } from '@app/shared/storage';

export const LOGIN_REDIRECT_KEY = 'LOGIN_REDIRECT_KEY';

@Injectable({
  providedIn: 'root',
})
export class PermanentStorageService {
  private storage = inject<Storage>(STORAGE_TOKEN);


  public setLoginRedirectUrl(url: string): void {
    this.storage.setItem(LOGIN_REDIRECT_KEY, url);
  }

  public popLoginRedirectUrl(): string | null {
    const value = this.storage.getItem(LOGIN_REDIRECT_KEY);
    this.storage.removeItem(LOGIN_REDIRECT_KEY);
    return value;
  }
}
